import React from 'react';
import { FormBuilder } from '@/features/form-builder';
import useFeedbackManagementStore from '@/stores/AdminStore/FeedbackManagementStore';

const AdminFormBuilder: React.FC = () => {
  const store = useFeedbackManagementStore();
  return <FormBuilder service={store} hasAIAssist />;
};

export default AdminFormBuilder;
